import { TableCellPerColumn } from "ds/components/TableSimple/types";

import { WORKER_POOLS_COLUMN_ID } from "../constants";
import { WorkerPoolsTableRow } from "../types";
import WorkerPoolsTableBusyCell from "./BusyCell";
import WorkerPoolsTableDescriptionCell from "./DescriptionCell";
import WorkerPoolsTableDropdownCell from "./DropdownCell";
import WorkerPoolsTableLabelsCell from "./LabelsCell";
import WorkerPoolsTableNameCell from "./NameCell";
import WorkerPoolsTableQueueCell from "./QueueCell";
import WorkerPoolsTableSpaceCell from "./SpaceCell";
import WorkerPoolsTableWorkersCell from "./WorkersCell";

export const WORKER_POOLS_TABLE_CELLS: TableCellPerColumn<WorkerPoolsTableRow> = {
  [WORKER_POOLS_COLUMN_ID.NAME]: WorkerPoolsTableNameCell,
  [WORKER_POOLS_COLUMN_ID.DESCRIPTION]: WorkerPoolsTableDescriptionCell,
  [WORKER_POOLS_COLUMN_ID.LABELS]: WorkerPoolsTableLabelsCell,
  [WORKER_POOLS_COLUMN_ID.SPACE]: WorkerPoolsTableSpaceCell,
  [WORKER_POOLS_COLUMN_ID.WORKERS]: WorkerPoolsTableWorkersCell,
  [WORKER_POOLS_COLUMN_ID.BUSY]: WorkerPoolsTableBusyCell,
  [WORKER_POOLS_COLUMN_ID.QUEUE]: WorkerPoolsTableQueueCell,
  [WORKER_POOLS_COLUMN_ID.DROPDOWN]: WorkerPoolsTableDropdownCell,
};
